import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const InquiryListComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <b className={styles.pageTitle}>받은 문의</b>
      </div>
      
      <div className={styles.pageContent}>
        <p>받은 문의 관리 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default InquiryListComponent;
